import React from 'react';

import { cn } from 'lib/helpers/utility';

import Icon from '../Icon/Icon';

/**
 * @param {import('./lib/propTypes').KeyProps}
 */

const Key = ({ text, theme = 'dark', icon }) => {
  const isDark = theme === 'dark';

  return (
    <div
      className={cn(
        'flex h-fit w-fit items-center justify-center rounded-[3px]',
        isDark
          ? 'bg-gradient-to-b from-neutral-800 to-neutral-700 p-[1px]'
          : 'border border-solid border-neutral-400'
      )}>
      <div
        className={cn(
          'flex h-fit min-h-[18px] w-fit min-w-[18px] items-center justify-center rounded-[3px] p-[3px]',
          isDark ? 'bg-neutral-800 text-white' : 'bg-neutral-75 text-neutral-800'
        )}>
        {!icon && (
          <span className="text-center font-apple text-xxs font-500 leading-none">{text}</span>
        )}
        {icon && <Icon icon={icon} color={isDark ? 'white' : 'neutral-800'} size={10} />}
      </div>
    </div>
  );
};

export default Key;
